// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27zVl","left":"styles_left__1nd8u","desktopActions":"styles_desktopActions__ewgCx","title":"styles_title__QIA-5"};